import type { Atom } from "#public"
import type { GUID } from "#public"
import type { Sequence } from "#public"

import { AtomToUint8 } from "../bytes/AtomToUint8"
import { Map } from "../functions/Map"
import { UInt8Hash } from "./UInt8Hash"

/**
 * Computes SHA-256 hash of a stream of atomic values.
 *
 * Converts each atom to bytes and computes a deterministic hash.
 *
 * @param stream - Async sequence of atomic values (string | number | bigint | boolean)
 * @returns Promise resolving to GUID hash
 *
 * @example
 * ```ts
 * import { AtomHash } from "@pdfking/tfunc"
 *
 * AtomHash(["hello", 42, true])
 * ```
 */
export const AtomHash = (stream: Sequence<Atom>): GUID => UInt8Hash(Map(AtomToUint8, stream))
